/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

const Footer = () => {
  return (
    <footer className="px-4 mb-2 mb-sm-0">
      <div className="d-flex flex-wrap justify-content-between">
        <p className="col-md-6 text-start">© 2024 saferetirementspending.com</p>
        <div className="col-md-6 text-end">
          <a className="text-decoration-none text-muted me-3" href="/">
            Calculator
          </a>
          <a className="text-decoration-none text-muted me-3" href="/about">
            About
          </a>
          <a className="text-decoration-none text-muted" href="/disclaimers">
            Disclaimers
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
